export default {"src":"/uk/_next/static/media/error-icon.e57fb878.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};